import React from 'react';

function EmbedThumbnailDropdownItem({ onClick }) {
  return (
    <li className="copy-link-item" onClick={onClick}>
      <div className="icon" />
      <span>Linked GIF</span>
    </li>
  );
}

export default EmbedThumbnailDropdownItem;
